import { Component, OnInit, effect } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { NgIf } from '@angular/common';
import { map, debounceTime } from 'rxjs/operators';
import * as Forge from 'node-forge';

import { Session, TrimmedSession } from '../../../shared/models/session.model';
import { DirectSessionLogicService } from '../../../shared/direct-session-logic.service';
import { environment } from '../../../../environments/environment';
import { ConfigData, LegalData, PageNotes } from '../../../shared/models/config-data.model';
import { DirectApiService } from '../../../shared/directApi.service';
import { ItemFormat } from '../../../shared/models/itemFormat.model';
import { CustomerFormat } from '../../../shared/models/customerFormat.model';
import { FormPaymentCcIconsComponent } from './form-payment-cc-icons/form-payment-cc-icons.component';





@Component({
  selector: 'app-form-container',
  template: `
<div>
    <h2>Secure Checkout</h2>
    <div>
        <p>{{this.pageDescription}}</p>
    </div>
    <hr>
                            <!-- <div class="form-group d-none">
                                <label for="selectPaymentType">Payment Type</label>
                                <select id="selectPaymentType" class="form-select" disabled="disabled">
                                    <option value="cc">Credit Card</option>
                                    <option value="ach">ACH</option>
                                </select>
                            </div> -->
    <form [formGroup]="paymentForm">
        <div class="mb-3">
            <div class="col-12">
                <label class="form-label" for="cardHolderName">Card Holder Name</label>
                <input formControlName="cardHolderName" type="text" class="form-control" name="name" placeholder="Enter Full Name" autocomplete="cc-name">
                @if(paymentForm.controls['cardHolderName'].invalid && paymentForm.controls['cardHolderName'].touched){
                    <div class="text-danger"> Please enter a valid name (first name and last name only). </div>
                }
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-12">
                <div >
                    <label class="form-label d-inline-block me-2" for="cardNumber">Card Number </label>
                    <app-form-payment-cc-icons class="d-inline-block" [creditCardType]="this.cardTypeOutput"></app-form-payment-cc-icons>
                </div>

                <div class="cc-input-icon">
                    <input formControlName="cardNumber" type="text" class="form-control" name="cardNumber" placeholder="xxxx xxxx xxxx xxxx" inputmode="numeric" autocomplete="cc-number" required minlength="18" maxlength="19" (input)="formatCardNumber($event)">
                    <img src="assets/Icons/credit-card.svg" alt="creditcard" class="icon-class">
                </div>

                @if(paymentForm.controls['cardNumber'].invalid && paymentForm.controls['cardNumber'].touched){
                    <div class="text-danger"> Please enter a valid credit card number. </div>
                }
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-6">
                <div class="form-group">
                    <label class="form-label" for="expireMonth">Expiration Date</label>
                    <div class="row">
                        <div class="col">
                            <input formControlName="expireDate" type="text" class="form-control" autocomplete="cc-exp" name="expireDate" placeholder="MM/YY" inputmode="numeric" required minlength="5" maxlength="5" (input)="formatExpirationDateCC($event)">
                        </div>
                    </div>
                    @if( (paymentForm.controls['expireDate'].invalid || paymentForm.controls['expireMonth'].invalid || paymentForm.controls['expireYear'].invalid) 
                        && paymentForm.controls['expireDate'].touched){
                        <div class="text-danger"> Please enter a valid credit card expiration date. </div>
                    }
                </div>
            </div>
            
            <div class="col-6">
                <div>
                    <label class="form-label" for="cvc">CVC</label>
                    <input formControlName="cvc" type="tel" class="form-control" name="cvc" placeholder="Enter CVC" autocomplete="cc-csc" inputmode="numeric" required minlength="3" maxlength="4">
                    @if(paymentForm.controls['cvc'].invalid && paymentForm.controls['cvc'].touched){
                        <div class="text-danger"> 3-4 digits </div>
                    }
                </div>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-6">
                <label class="form-label" for="zipCode">Billing Zip Code</label>
                <input formControlName="zipCode" type="tel" class="form-control" name="zip" placeholder="Enter Zip Code" inputmode="numeric" autocomplete="postal-code" required minlength="5" maxlength="5">
                @if(paymentForm.controls['zipCode'].invalid && paymentForm.controls['zipCode'].touched){
                    <div class="text-danger"> Please enter a valid zip code. </div>
                }
            </div>

            <div class="col-6">
            </div>
        </div>


        <div class="row mb-3">
            <div class="col-12 col-sm-auto col-md-auto">
                <input formControlName="inputacceptTerms" name="inputacceptTerms" type="checkbox" class="termsCheckBox" inputmode="checkbox" >
            </div>

            <div class="col-12 col-sm-10 col-lg-10">
                @if(paymentForm.controls['inputacceptTerms'].invalid && paymentForm.controls['inputacceptTerms'].touched){
                    <div class="text-danger"> You are required to accept these terms to purchase a plan. </div>
                }
                <label class="legal-terms-text" for="inputacceptTerms">{{this.acceptTermsLegalText}}</label>
            </div>
        </div>

    </form>                       

</div>
  `,
  styleUrls: ['./form-payment.component.scss'],
  standalone: true,
  imports: [ ReactiveFormsModule, FormPaymentCcIconsComponent]
})
export class FormPaymentPage implements OnInit{
    get selections(): ItemFormat[] {
        return this.directSessionLogic.cartItemsSignal();
    }
    get customer(): CustomerFormat {
        return this.directSessionLogic.customerSignal();
    }
    get trimmedSession(): TrimmedSession {
        return this.directSessionLogic.trimmedSessionSignal();
    }
    get totalCost(): number {
        return this.trimmedSession.totalCost;
    }
    get session(): TrimmedSession {
        return this.directSessionLogic.trimmedSessionSignalValue;
    }


    paymentForm: FormGroup = new FormGroup({});
    acceptTermsLegalText: string = "I agree to the $_$ terms and conditions";

    pageNotes: PageNotes[] = [];
    pageDescription: string = "";

    legalData: LegalData[] = [];
    
    configData: ConfigData = {} as ConfigData;

    cardHolderName: string = '';
    cardNumber: string = '';
    expireMonth: string = '';
    expireYear: string = '';
    expireDate: string = '';
    cvc: string = '';
    streetAddress: string = '';
    zipCode: string = '';
    // inputEmailAddress: string = '';
    inputacceptTerms: boolean = false;

    formComplete: boolean = false;

    cardTypeOutput: string = '';

    errorLoop: number = 0;
    // emailRegex: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/;
    fullNameRegex: RegExp = /^[a-zA-Z\s-]+$/; // /^[a-zA-Z\s]+\s[a-zA-Z]+$/; //old regex unused
    permissiveNameRegex: RegExp = /^[a-zA-Z\s-]+$/;
    ccRegex: RegExp = /^\d{4}\s\d{4}\s\d{4}\s\d{3,4}$/;
    cvcRegex: RegExp = /^\d{3,4}$/;
    zipCodeRegex: RegExp = /^\d{5}$/;
    expDateRegex: RegExp = /^\d{2}\/\d{2}$/;
    
    publicKey: string = "zEVaNNx2WbwTuGUHSus4rzRtrmtaot9txX0YePUrpHeV2x1MZoCp2vtfsEpcRIucssaSm45hk81e/w3I6DRYp9NLinHC1Fsfj6a381T/GJ3JMPVJUPQVma/GIvEE/H6840JhdeG5atieuFNCHmjTQZjps3HrwZEnym8A3KB49sE=";

    constructor(
        public directSessionLogic: DirectSessionLogicService,
        private router: Router,
        private builder: FormBuilder,
        private apiService: DirectApiService
    ) {
        this.configData = environment as ConfigData;
        // console.log("form payment component config data", this.configData);
        this.initPaymentDetails();

        effect(() => {
            this.initPaymentDetails();
        });

        if(this.directSessionLogic.trimmedSessionSignal().customerId === undefined) {
            this.directSessionLogic.escapeToTopLevelSignal()
        }

        this.paymentForm = this.builder.group({
            cardHolderName:     ['', [Validators.required, Validators.minLength(5), Validators.maxLength(48), Validators.pattern(this.permissiveNameRegex) ]], 
            cardNumber:         ['', [Validators.required, Validators.minLength(18), Validators.maxLength(20), Validators.pattern(this.ccRegex) ]],
            expireMonth:        ['', [Validators.minLength(1), Validators.maxLength(2), Validators.min(1), Validators.max(12) ]], 
            expireYear:         ['', [Validators.minLength(1), Validators.maxLength(2), Validators.min(0), Validators.max(99) ]], 
            expireDate:         ['', [Validators.required, Validators.minLength(5), Validators.maxLength(5), Validators.pattern(this.expDateRegex) ]],
            cvc:                ['', [Validators.required, Validators.minLength(3), Validators.maxLength(4), Validators.pattern(this.cvcRegex) ]],
            zipCode:            ['', [Validators.required, Validators.minLength(5), Validators.maxLength(5), Validators.pattern(this.zipCodeRegex) ]],
            inputacceptTerms:   ['', [Validators.required, Validators.requiredTrue ]],
        });
    }

    async initPaymentDetails() {
        this.acceptTermsLegalText = this.configData.LegalData
            .find(x=> x.legalRef == "terms" )?.legalText 
                || "Error displaying legal text. Total cost for this plan is: $_$";

        //May want to add a subscripiton to the legal data in the future so it updates with the cart
        this.acceptTermsLegalText = this.acceptTermsLegalText.replace(
            "$_$", this.trimmedSession.totalCost.toString()
        );

        const agilityPrefix = this.directSessionLogic.agilityObjectsSignal().subscriptionAcceptanceDetails ?? '';
        this.acceptTermsLegalText = agilityPrefix + this.acceptTermsLegalText;
    }


    ngOnInit() {
        this.getPageDataFromConfig();

        let dateUpdate = true;
        let cardUpdate = true;

        this.paymentForm.valueChanges.pipe(
            debounceTime(300)
        ).subscribe(() => {
            console.log("---");
            // console.log("form value changes", this.paymentForm.value);

            if(this.paymentForm.get('expireDate')?.value < 5){
                dateUpdate = true;
            }
            
            if(this.paymentForm.get('cardNumber')?.valid && 
                cardUpdate === true ) {

                console.log("card number filled");
                this.customer.cardType = this.cardType(this.paymentForm.value.cardNumber);
                cardUpdate = false;
            }else if(this.paymentForm.get('cardNumber')?.value.length < 18){
                this.cardTypeOutput = '';
                cardUpdate = true;
            }

            if(this.paymentForm.get('expireDate')?.valid && 
                dateUpdate === true && 
                this.paymentForm.get('expireDate')?.value.length === 5){
                
                this.splitExpDate();
                console.log("expire date filled")
                dateUpdate = false;
            }


            if(this.paymentForm.valid && this.paymentForm.get('expireDate')?.value.length === 5){
                this.formComplete = true;
                console.log("form complete", this.formComplete);
                this.customer.cardHolderName = this.paymentForm.value.cardHolderName;

                this.customer.ccLast4 = this.paymentForm.value.cardNumber.toString().slice(-4);
            
                const publicKey = Forge.pki.setRsaPublicKey(this.parseBigInteger(this.publicKey), this.parseBigInteger('AQAB'));
                const cardBuffer = Forge.util.createBuffer(this.paymentForm.value.cardNumber.replaceAll(' ', ''), 'utf8');
                const dateBuffer = Forge.util.createBuffer(this.paymentForm.value.expireDate, 'utf8');
                const cardEncrypted = Forge.util.encode64(publicKey.encrypt(cardBuffer.bytes(), 'RAW'));
                const dateEncrypted = Forge.util.encode64(publicKey.encrypt(dateBuffer.bytes(), 'RAW'));

                this.customer.cardEncrypted = cardEncrypted;
                this.customer.dateEncrypted = dateEncrypted;
                

                //update customer??
                this.directSessionLogic.updateCustomerSignal(this.customer);
                this.directSessionLogic.completeCurrentPage();

            }
            else
            {
                this.formComplete = false;
                this.directSessionLogic.unCompleteCurrentPage();

                let invalidFields = "Invalid Fields: "
                for (const name in this.paymentForm.controls) {
                    if (this.paymentForm.controls[name].invalid) {
                      invalidFields += name + ", ";
                    }
                }   
                
                console.log(invalidFields);
            }
        });

        // Non-prod builds with localDebug on pre-fill the payment form with test data.
        // environment.production is a build-time constant, so this block is dead code
        // (tree-shaken) in the prod build.
        if(!environment.production && environment.ConnectionInfo.localDebug === "true") {
            this.loadDebugData();
        }
    }

    async splitExpDate() {
        console.log("expire date filled")
        let expDate = this.paymentForm.value.expireDate.split('/');

        this.paymentForm.patchValue({
            expireMonth: expDate[0],
            expireYear: expDate[1]
        })

        console.log("expire date", expDate[0], expDate[1]);
    }

    async getPageDataFromConfig(){
        //gets subtext for the page
        let pageRefId = this.directSessionLogic.getCurrentStepSignal().reference;

        this.pageNotes = this.configData.PageNotes.filter( note => 
            note.PageRef === pageRefId
        );
    
        this.pageDescription = this.pageNotes[0]?.PageNote.toString() ?? "";
    }

    cardType(cardNumber: string): string {
        let cardType: string = '';

        let cardNumFirst = this.paymentForm.value.cardNumber.toString().slice(0,1);
        switch(cardNumFirst){
            case "4":
                cardType = "Visa";
                break;
            case "2": case "5":
                cardType = "Mastercard";
                break;
            case "6":
                cardType = "Discover";
                break;
            case "3":
                cardType = "American Express";
                break;
            default:
                cardType = "Other Credit Card";
                break;
        }

        console.log("card type: ", cardType);
        this.cardTypeOutput = cardType;
        return cardType;
    }

    formatCardNumber(event: Event) {
        let input = (event.target as HTMLInputElement).value.replace(/\D/g, ''); // Remove non-numeric characters
        let formattedInput = input.replace(/(\d{4})(?=\d)/g, '$1 '); // Add a space after every 4 digits
        if (this.paymentForm.controls['cardNumber'].value !== formattedInput) {
            // Save the current cursor position
            let cursorPos = (event.target as HTMLInputElement).selectionStart ?? 0;
            // Calculate the new cursor position
            let newCursorPos = cursorPos + (formattedInput.length - this.paymentForm.controls['cardNumber'].value.length);
            this.paymentForm.controls['cardNumber'].setValue(formattedInput); // Update the form control value
            // Set the cursor position to the new position
            setTimeout(() => (event.target as HTMLInputElement).setSelectionRange(newCursorPos, newCursorPos), 0);
        }
    }

    formatExpirationDateCC(event: Event) {
        let input = (event.target as HTMLInputElement).value.replace(/\D/g, ''); // Remove non-numeric characters
        let formattedInput = input.replace(/(\d{2})(?=\d)/g, '$1/'); // Add a slash after every 2 digits
        if (this.paymentForm.controls['expireDate'].value !== formattedInput) {
            // Save the current cursor position
            let cursorPos = (event.target as HTMLInputElement).selectionStart ?? 0;
            // Calculate the new cursor position
            let newCursorPos = cursorPos + (formattedInput.length - this.paymentForm.controls['expireDate'].value.length);
            this.paymentForm.controls['expireDate'].setValue(formattedInput); // Update the form control value
            // Set the cursor position to the new position
            setTimeout(() => (event.target as HTMLInputElement).setSelectionRange(newCursorPos, newCursorPos), 0);
        }
    }

    parseBigInteger(b64: string):any {
        var BigInteger = Forge.jsbn.BigInteger;
        return new BigInteger(Forge.util.createBuffer(Forge.util.decode64(b64)).toHex(), 16);
    }

    // setPaymentFieldsFromSession(){
    //     this.paymentForm.patchValue({
    //         cardHolderName: this.session.customer.cardHolderName ?? '',
    //         // cardNumber: this.session.customer.,
    //         expireDate: this.session.customer.ccExpMonth + '/' + this.session.customer.ccExpYear ?? '',
    //         // cvc: this.session.customer.,
    //         // zipCode: this.session.customer.,
    //         // inputacceptTerms: this.session.customer.inputacceptTerms
    //     });
    
    // }

    loadDebugData() {
        console.log("Debug mode is on");
        this.paymentForm.patchValue({
            cardHolderName: 'John Doe',
            cardNumber: '4111 1111 1111 1111',
            expireDate: '12/25',
            cvc: '123',
            zipCode: '12345',
            inputacceptTerms: true
        });
    }

    
}